import { TableColumnMeta } from "ds/components/Table/types";

export enum SPACELIFT_VCS_REPO_FILES_COLUMN_ID {
  NAME = "NAME",
  COMMIT = "COMMIT",
  COMMIT_MESSAGE = "COMMIT_MESSAGE",
  UPDATED_AT = "UPDATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const SPACELIFT_VCS_REPO_FILES_COLUMNS_STORAGE_KEY = "spaceliftVcsRepoFilesColumnsConfig";

export const SPACELIFT_VCS_REPO_FILES_COLUMN_CONFIG: Record<
  SPACELIFT_VCS_REPO_FILES_COLUMN_ID,
  TableColumnMeta
> = {
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.NAME]: {
    id: SPACELIFT_VCS_REPO_FILES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 200,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: false,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.COMMIT]: {
    id: SPACELIFT_VCS_REPO_FILES_COLUMN_ID.COMMIT,
    title: "Commit",
    minWidth: 120,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.COMMIT_MESSAGE]: {
    id: SPACELIFT_VCS_REPO_FILES_COLUMN_ID.COMMIT_MESSAGE,
    title: "Commit message",
    minWidth: 200,
    defaultWidth: 350,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.UPDATED_AT]: {
    id: SPACELIFT_VCS_REPO_FILES_COLUMN_ID.UPDATED_AT,
    title: "Updated at",
    minWidth: 170,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.DROPDOWN]: {
    id: SPACELIFT_VCS_REPO_FILES_COLUMN_ID.DROPDOWN,
    title: "Row actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};
